<div class='dialog'>
  <div class='icon'>
    <i class='fa fa-question-circle' aria-hidden='true'></i>
  </div>

  <div mat-dialog-content class='message'>
    <p>{{data.message  | translate: data.props}}</p>
  </div>

  <div class='line'></div>
  <div mat-dialog-actions class='buttons'>
    <a mat-raised-button class='default' (click)='onConfirm()' tabindex="-1">
<!--      <i class='fa fa-check' aria-hidden='true'></i> -->
      {{ data.ok | translate }}
    </a>
    <a mat-raised-button class='default' (click)='onDismiss()' tabindex="-1">
<!--      <i class='fa fa-close' aria-hidden='true'></i> -->
      {{ data.cancel | translate }}
    </a>
  </div>
</div>
